import _ from "lodash";
import { getInstance as getDataSources } from "datasources";
import { getInstance as getStore } from "../../../store/store";
import ErrorCodes from "errorcodes";
import { hashHistory } from "react-router";

import { setLoaderVisibility } from "../../../store/actions/loader";
import { updateUserHouseholdId } from "../../../store/actions/user";

import {
  hideModal,
  ModalStatus,
  ModalTypes,
  setModalType,
  setStatus as setModalStatus,
  showModal,
} from "../../../store/actions/modal";

import {
  attemptLogin,
  LoginStatus,
  loginUser,
  setFormData as setLoginFormData,
  setStatus as setLoginModalStatus,
} from "../../../store/actions/modals/login";

import { PaymentStatus, setStatus as setPaymentStatus, subscribe } from "../../../store/actions/payment";

import { attemptSessionRefresh } from "../../../store/actions/session";

import AnalyticsEventsManager from "../../../utils/firebase/index.js";

import operatingSystem from "lib/checkuseros";
import startAndroidApp from "lib/startandroidapp";
import startIOSApp from "lib/startiosapp";

// Action types
const ActionTypes = {
        SET_REGISTER_FORM_STATUS: 'SET_REGISTER_FORM_STATUS',
        SET_REGISTER_FORM_DATA: 'SET_REGISTER_FORM_DATA',
        RESET_REGISTER_FORM_DATA: 'RESET_REGISTER_FORM_DATA',
        SET_REGISTER_FORM_ERROR: 'SET_REGISTER_FORM_ERROR',
        SET_REGISTER_PRODUCT_PRICE: 'SET_REGISTER_PRODUCT_PRICE'
    },

    // Status values
    RegisterStatus = {
        INITIAL: 'initial',
        REQUEST_SUCCESS: 'request-success',
        REQUEST_FAILURE: 'request-failure',
        REGISTER_STEP_ONE: 'register-step-one',
        REGISTER_STEP_TWO: 'register-step-two'
    },
    eventsList = {
        API_ERROR: 'API_ERROR',
        LOGIN_EVENT: 'login',
        REGISTRATION_FIRST_STEP: 'REGISTRATION_FIRST_STEP',
        REGISTRATION_SECOND_STEP: 'REGISTRATION_SECOND_STEP',
        REGISTRATION_THIRD_STEP: 'REGISTRATION_THIRD_STEP',
        SUCCESS_PAGE: 'SUCCESS_PAGE',
        CANCEL_SUBSCRIPTION: 'CANCEL_SUBSCRIPTION'
    },
    RegisterStepList = {
        FIRST_STEP: 'step-one',
        SECOND_STEP: 'step-two',
        THIRD_STEP: 'step-three',
        SELECT_ACCOUNT_TYPE_PAGE: 'select-account-type',
        IOS_STEP: 'step-one-IAP'
    };

const verifier = {
    api_key:'c981c2a52d034118ab01cfcf49de5e7e',
    api_endpoint: 'https://api.zerobounce.net/v1/validate?apikey='
};

/**
 * Set status action.
 *
 * @param {string} status - New status of the component.
 * @returns {Object} Action type and the new status.
 */

function setStatus (status = RegisterStatus.INITIAL) {

    return {
        type: ActionTypes.SET_REGISTER_FORM_STATUS,
        status
    };
}

/**
 * Set form data action.
 *
 * @param {Object} [values] - Data of form.
 * @returns {Object} Action type, user's name and password.
 */
function setFormData (values) {
    return {
        type: ActionTypes.SET_REGISTER_FORM_DATA,
        formData: values
    };
}

function resetFormData () {
    return {
        type: ActionTypes.RESET_REGISTER_FORM_DATA
    };
}

/**
 * Set product price action.
 *
 * @param {Object} productPrice - Data.
 * @returns {Object} Action type, product price.
 */
function setProductPrice (productPrice) {
    return {
        type: ActionTypes.SET_REGISTER_PRODUCT_PRICE,
        productPrice: productPrice
    };
}

/**
 * Set error action.
 *
 * @param {Object} error - Error object with reason message.
 * @returns {Object} Action type and error object.
 */
function setError (error) {

    return {
        type: ActionTypes.SET_REGISTER_FORM_ERROR,
        formError: error
    };
}

function sendHooligansEvent (props) {
    const { event , gaEventCategory, gaEventAction, gaEventLabel, gaPageviewPath } = props;

    window.dataLayer.push({ 
        event,
        gaEventCategory,
        gaEventAction,
        gaEventLabel,
        gaPageviewPath
    });
}

function getStepName () {
    const store = getStore().getState(),
        { form: { RegisterForm: { registeredFields }}} = store;

    let isFirstStep = Object.keys(registeredFields)
        .findIndex(item => item === 'firstName') >= 0,
        stepName = isFirstStep
            ? eventsList.REGISTRATION_FIRST_STEP
            : eventsList.REGISTRATION_SECOND_STEP;

    return stepName;
}

/**
 * Attempt to register action.
 *
 * @returns {Promise} Response to the request.
 */
function attemptRegister (isBigiPlusPackage = true, isNewRegistration) {
    return (dispatch, getState) => {
        let dataSources = getDataSources(),
            state = getState(),
            registerFormData = isNewRegistration ? _.get(state, ['newRegistration', 'user']) : _.get(state, ['register', 'formData']),
            userOS = operatingSystem;

        dispatch(setModalStatus(ModalStatus.LOADING));

        return dataSources.registerUser(registerFormData)
            .then(() => {
                dispatch(setError(null));
                dispatch(setStatus(RegisterStatus.REQUEST_SUCCESS));
                dispatch(hideModal());

                // payment process starts here
                dispatch(setPaymentStatus(PaymentStatus.PROCESSING_PAYMENT));
                if (userOS === 'Android' ||  userOS === 'iOS') {
                    if (userOS === 'Android') {
                        startAndroidApp();
                    } else if (userOS === 'iOS') {
                        startIOSApp();
                    }
                } else {
                    return dispatch(attemptLogin(
                        registerFormData.email,
                        registerFormData.password,
                        true
                    ));
                }

            })
            .catch((response) => {
                dispatch(setLoaderVisibility(false));
                let error = _.get(response, ['result', 'error']),
                    {message, code} = error;

                if (error && (typeof error === 'string' || message)) {
                    error = message || error;
                } else {

                    error = 'Unknown Error';
                }

                let analytics = new AnalyticsEventsManager();

                analytics.sendApiErrorEvent({
                    message,
                    code,
                    userName: registerFormData.email
                });

                if(!isNewRegistration) {
                    sendHooligansEvent({
                        event: 'gaEventRegistrationProcessError',
                        gaEventCategory: 'Regisration Process',
                        gaEventAction: getStepName(),
                        gaEventLabel: `Error - General - ${message}`
                    });
                }
               
                // user already exists - show login dialog
                if (code === ErrorCodes.USER_EXISTS) {
                    dispatch(setError(null));
                    dispatch(setStatus(RegisterStatus.REQUEST_FAILURE));
                    dispatch(hideModal());

                    // set login form username
                    dispatch(setLoginFormData({
                        username: registerFormData.email || '',
                        password: ''
                    }));
                    dispatch(setModalStatus(ModalStatus.SHOW));
                    dispatch(setLoginModalStatus(LoginStatus.USER_EXISTS));
                    dispatch(setModalType(ModalTypes.LOGIN));
                    dispatch(showModal());
                    localStorage.setItem('isErrorOnRegistrationProcess', 'EXIST')
                } else {
                    dispatch(setError(error));
                    dispatch(setStatus(RegisterStatus.REQUEST_FAILURE));
                    dispatch(setModalStatus(ModalStatus.ERROR));
                    localStorage.setItem('isErrorOnRegistrationProcess', 'OTHER')
                }

                dispatch(setPaymentStatus(PaymentStatus.REQUEST_FAILURE));

            }).then(() => {
                const householdData = {
                    name: registerFormData.email
                };

                // Create new household and assign it to new user

                return dataSources.createHousehold(householdData).catch((response) => {
                    let error = _.get(response, ['result', 'error']),
                        {message} = error;

                    if (error && (typeof error === 'string' || message)) {
                        error = message || error;
                    } else {

                        error = 'Unknown Error';
                    }

                    dispatch(setError(error));
                    dispatch(setStatus(RegisterStatus.REQUEST_FAILURE));
                    dispatch(setModalStatus(ModalStatus.ERROR));
                    dispatch(setPaymentStatus(PaymentStatus.REQUEST_FAILURE));
                });
            }).then(() => {
				switch (localStorage.getItem('isErrorOnRegistrationProcess')) {
					case 'EXIST':
						localStorage.removeItem('isErrorOnRegistrationProcess')
						hashHistory.push('/')
						console.trace("hashHistory.push");

						break;
					case 'OTHER':
						localStorage.removeItem('isErrorOnRegistrationProcess')
						
						break;
					default:
						break;
				}
				
                if(isBigiPlusPackage) {
                    sendHooligansEvent({
                        event: 'gaPageviewRegistrationProcessSteps',
                        gaPageviewPath: '/registrationProcess/step3-payment'
                    });
                    localStorage.setItem('login.success', 'true')

                    dispatch(subscribe());
                } else {
                    dispatch(setPaymentStatus(PaymentStatus.INITIAL));

                    localStorage.setItem('registration.success', 'true')

                    hashHistory.push(isNewRegistration ? '/register/step/6': '/success')
					console.trace("hashHistory.push");

					dispatch(setLoaderVisibility(false));
                }

            });
    };
}

function registerUser() {
  return new Promise(async (resolve, reject) => {
    const store = getStore();

    const dataSources = getDataSources();
    const state = store.getState();

    const registerFormData = state.newRegistration.user;

    try {
      await dataSources.registerUser(registerFormData);
    } catch (error) {
      reject(error.result.error);
    }

    try {
      await loginUser(
        registerFormData.email,
        registerFormData.password,
        true
      );

	  localStorage.setItem('login.success', 'true')
	  localStorage.setItem('registration.success', 'true')
	  
      resolve();
    } catch (error) {
      reject(error.result.error);
    }
  });
}

function attemptAddHousehold(householdData) {
  return (dispatch) => {
    let dataSources = getDataSources();

    return dataSources.createHousehold(householdData)
      .then((result) => {
        const id = result.result.id;
        if (id) dispatch(updateUserHouseholdId(id));
      })
      .catch((response) => {
        if (response) {
          let error = _.get(response, ["result", "error"]),
            { message } = error;

          if (error && (typeof error === "string" || message)) {
            error = message || error;
          } else {

            error = "Unknown Error";
          }

          dispatch(setError(error));
          dispatch(setStatus(RegisterStatus.REQUEST_FAILURE));
          dispatch(setModalStatus(ModalStatus.ERROR));
          dispatch(setPaymentStatus(PaymentStatus.REQUEST_FAILURE));
        }
      });
  };
}

function addSubscription(isBigiPlusPackage) {
  return (dispatch, getState) => {
    if (isBigiPlusPackage) {
      sendHooligansEvent({
        event: "gaPageviewRegistrationProcessSteps",
        gaPageviewPath: "/registrationProcess/step3-payment",
      });
      localStorage.setItem("login.success", "true");

      dispatch(subscribe());
    } else {
      localStorage.setItem("registration.success", "true");
      hashHistory.push("/register/step/6");
    }
  };
}

/**
 * Attempt to check user exists action.
 *
 * @param {string} username - User's name.
 * @returns {Function} Function that returns a promise
 * resolving to login response.
 */
function checkUserExists (username) {
    return (dispatch) => {
        let dataSources = getDataSources();

        return dataSources.checkUserExistance({
            username: username
        })
            .catch((response) => {
                dispatch(setStatus(LoginStatus.REQUEST_FAILURE));
                dispatch(setModalStatus(ModalStatus.ERROR));
                return Promise.reject(response);
            });
    };
}

/**
 * Lists product prices.
 *
 * @returns {Promise} Response to the request.
 */
function listPrice () {
    return (dispatch, getState) => {

        let dataSources = getDataSources(),
            productPrice = {},
            subscriptionId = null;

        return dataSources.getConfig().then((config) => {
            return _.get(config, ['_presets', 'subscriptionId']) || _.get(config, ['subscriptionId']);
        }).then((subId) => {
            subscriptionId = subId;

            let wasUpdated = _.get(getState(), ['session', 'wasUpdated']);
 
            if (wasUpdated || wasUpdated === undefined) {
                return Promise.resolve();
            }
            return dispatch(attemptSessionRefresh(false, true));
        }).then(() => {
            return dataSources.getSubscriptions(subscriptionId).then((subscription) => {
                let {price} = subscription;

                productPrice.price = price.amount;
                productPrice.currencySign = price.sign;
                productPrice.currency = price.currency;
                dispatch(setProductPrice(productPrice));
            });
        });
    };
}

// https://cors-anywhere.herokuapp.com/

async function checkEmailValidationStatus (enteredEmail) {
    return fetch(`${verifier.api_endpoint}${verifier.api_key}&email=${enteredEmail}`, {
        method: 'GET'
    }).then((response)=> response.json());
   
}

// Exposed elements of the actions file.
export {
    ActionTypes,
    RegisterStatus,
    RegisterStepList,
    setStatus,
    setFormData,
    resetFormData,
    setError,
    attemptRegister,
    attemptAddHousehold,
    checkUserExists,
    listPrice,
    checkEmailValidationStatus,
	registerUser,
	addSubscription,
};


// WEBPACK FOOTER //
// ./src/js/store/actions/modals/register.js